export default "/_next/static/images/circle-29ab0f76c3c0a30b99b9a85e5b96754a.svg";